import type * as React from "react";

import {
    useRegionOverride,
    type RegionOverrideResult,
} from "@khan/data-region-override";

type Props = {
    children: (props: RegionOverrideResult) => React.ReactElement | null;
    shouldSSR?: boolean;
};

export const RegionOverrideQuery = (props: Props) => {
    const {children, shouldSSR} = props;
    const result = useRegionOverride(shouldSSR);
    return children(result);
};
